import React, { useCallback, useMemo, useState } from 'react';
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption, } from 'reactstrap';
var Slider = function (_a) {
    var id = _a.id, items = _a.items, _b = _a.intervalMs, intervalMs = _b === void 0 ? 5000 : _b, isHoverPlay = _a.isHoverPlay, className = _a.className;
    var _c = useState(0), activeIndex = _c[0], setActiveIndex = _c[1];
    var _d = useState(false), animating = _d[0], setAnimating = _d[1];
    var _e = useState(!isHoverPlay), play = _e[0], setPlay = _e[1];
    var goToNext = useCallback(function () {
        if (animating) {
            return;
        }
        var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    }, [activeIndex, animating, items.length]);
    var goToPrevious = useCallback(function () {
        if (animating) {
            return;
        }
        var nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    }, [activeIndex, animating, items.length]);
    var goToIndex = useCallback(function (newIndex) {
        if (animating) {
            return;
        }
        setActiveIndex(newIndex);
    }, [animating]);
    var getSlides = useMemo(function () {
        return items.map(function (item) {
            return (React.createElement(CarouselItem, { onExiting: function () { return setAnimating(true); }, onExited: function () { return setAnimating(false); }, key: id + item.src }, item.link ? (React.createElement("a", { href: item.link },
                React.createElement("img", { src: item.src, alt: item.altText, className: 'slider w-100' }),
                React.createElement(CarouselCaption, { captionText: item.caption, captionHeader: item.caption }))) : (React.createElement("div", null,
                React.createElement("img", { src: item.src, alt: item.altText, className: 'slider w-100' }),
                React.createElement(CarouselCaption, { captionText: item.caption, captionHeader: item.caption })))));
        });
    }, [id, items]);
    // const renderContent: React.ReactElement = useMemo(() => {
    //   if (isHoverPlay) {
    //     if (play) {
    //       console.log('isHoverPlay play')
    //       return (
    //         <Carousel
    //           key={id + '-play-on'}
    //           id={id + '-play-on'}
    //           activeIndex={activeIndex}
    //           next={goToNext}
    //           previous={goToPrevious}
    //           interval={intervalMs}
    //           ride={'carousel'}
    //           pause={false}
    //           mouseEnter={() => {
    //             setPlay(true)
    //           }}
    //           mouseLeave={() => {
    //             setPlay(false)
    //             setAnimating(false)
    //           }}
    //           className={'slider ' + (className ? className : '')}>
    //           <CarouselIndicators
    //             items={items}
    //             activeIndex={activeIndex}
    //             onClickHandler={goToIndex}
    //           />
    //           {getSlides}
    //           <CarouselControl
    //             direction="prev"
    //             onClickHandler={goToPrevious}
    //             directionText="Previous"
    //           />
    //           <CarouselControl direction="next" onClickHandler={goToNext} directionText="Next" />
    //         </Carousel>
    //       )
    //     } else {
    //       console.log('isHoverPlay')
    //       return (
    //         <Carousel
    //           slide={false}
    //           key={id + '-play-off'}
    //           id={id + '-play-off'}
    //           activeIndex={activeIndex}
    //           next={goToNext}
    //           previous={goToPrevious}
    //           interval={false}
    //           ride={'carousel'}
    //           mouseEnter={() => {
    //             setPlay(true)
    //           }}
    //           mouseLeave={() => {
    //             setPlay(false)
    //           }}
    //           className={'slider ' + (className ? className : '')}>
    //           <CarouselIndicators
    //             items={items}
    //             activeIndex={activeIndex}
    //             onClickHandler={goToIndex}
    //           />
    //           {getSlides}
    //           <CarouselControl
    //             direction="prev"
    //             onClickHandler={goToPrevious}
    //             directionText="Previous"
    //           />
    //           <CarouselControl direction="next" onClickHandler={goToNext} directionText="Next" />
    //         </Carousel>
    //       )
    //     }
    //   } else {
    //     console.log('end')
    //     return (
    //       <Carousel
    //         key={id}
    //         id={id}
    //         activeIndex={activeIndex}
    //         next={goToNext}
    //         previous={goToPrevious}
    //         interval={intervalMs}
    //         ride={'carousel'}
    //         pause={'hover'}
    //         className={'slider ' + (className ? className : '')}>
    //         <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
    //         {getSlides}
    //         <CarouselControl
    //           direction="prev"
    //           onClickHandler={goToPrevious}
    //           directionText="Previous"
    //         />
    //         <CarouselControl direction="next" onClickHandler={goToNext} directionText="Next" />
    //       </Carousel>
    //     )
    //   }
    // }, [
    //   activeIndex,
    //   className,
    //   getSlides,
    //   goToIndex,
    //   goToNext,
    //   goToPrevious,
    //   id,
    //   intervalMs,
    //   isHoverPlay,
    //   items,
    //   play,
    // ])
    var renderContent = useMemo(function () {
        if (isHoverPlay) {
            if (play) {
                return (React.createElement(Carousel, { key: id + '-play-on', id: id + '-play-on', activeIndex: activeIndex, next: goToNext, previous: goToPrevious, interval: intervalMs, ride: 'carousel', pause: false, mouseEnter: function () {
                        setPlay(true);
                    }, mouseLeave: function () {
                        setPlay(false);
                        setAnimating(false);
                    }, className: 'slider ' + (className ? className : '') },
                    React.createElement(CarouselIndicators, { items: items, activeIndex: activeIndex, onClickHandler: goToIndex }),
                    getSlides,
                    React.createElement(CarouselControl, { direction: "prev", onClickHandler: goToPrevious, directionText: "Previous" }),
                    React.createElement(CarouselControl, { direction: "next", onClickHandler: goToNext, directionText: "Next" })));
            }
            else {
                return (React.createElement(Carousel, { slide: false, key: id + '-play-off', id: id + '-play-off', activeIndex: activeIndex, next: goToNext, previous: goToPrevious, interval: false, ride: 'carousel', mouseEnter: function () {
                        setPlay(true);
                    }, mouseLeave: function () {
                        setPlay(false);
                    }, className: 'slider ' + (className ? className : '') },
                    React.createElement(CarouselIndicators, { items: items, activeIndex: activeIndex, onClickHandler: goToIndex }),
                    getSlides,
                    React.createElement(CarouselControl, { direction: "prev", onClickHandler: goToPrevious, directionText: "Previous" }),
                    React.createElement(CarouselControl, { direction: "next", onClickHandler: goToNext, directionText: "Next" })));
            }
        }
        else {
            return (React.createElement(Carousel, { key: id, id: id, activeIndex: activeIndex, next: goToNext, previous: goToPrevious, interval: intervalMs, ride: 'carousel', pause: 'hover', className: 'slider ' + (className ? className : '') },
                React.createElement(CarouselIndicators, { items: items, activeIndex: activeIndex, onClickHandler: goToIndex }),
                getSlides,
                React.createElement(CarouselControl, { direction: "prev", onClickHandler: goToPrevious, directionText: "Previous" }),
                React.createElement(CarouselControl, { direction: "next", onClickHandler: goToNext, directionText: "Next" })));
        }
    }, [
        activeIndex,
        className,
        getSlides,
        goToIndex,
        goToNext,
        goToPrevious,
        id,
        intervalMs,
        isHoverPlay,
        items,
        play,
    ]);
    return React.createElement(React.Fragment, null, renderContent);
};
export { Slider };
//# sourceMappingURL=Slider.js.map